import dayjs from 'dayjs';

const DISPLAY_FORMAT = 'DD/MM/YYYY';
const MISSING_VALUE_PLACEHOLDER = '—';

/**
 * Formats a date-like value as DD/MM/YYYY (date only, never a time-of-day
 * component). Accepts a millis number, a Firestore Timestamp-shaped value
 * ({ toMillis() }), an ISO "YYYY-MM-DD" calendar-date string, or null/undefined.
 * Returns "—" for anything missing or invalid - never blank, never an epoch date.
 *
 * @param {number | { toMillis: () => number } | string | null | undefined} value
 * @returns {string}
 */
export function formatDateDDMMYYYY(value) {
  if (value === null || value === undefined || value === '') return MISSING_VALUE_PLACEHOLDER;

  const millis = typeof value === 'object' && typeof value.toMillis === 'function'
    ? value.toMillis()
    : value;

  if (millis === 0) return MISSING_VALUE_PLACEHOLDER;

  const parsed = dayjs(millis);
  return parsed.isValid() ? parsed.format(DISPLAY_FORMAT) : MISSING_VALUE_PLACEHOLDER;
}
